// `/app/developers/docs` (`spec/17-frontend.md` §8.1). Tela estática: índice da doc
// pública (`DOCS_BASE_URL`, WEB-118/DOCS-01), nenhuma chamada do painel.

import { createFileRoute } from '@tanstack/react-router';
import { DocsScreen } from '../features/events/docs-screen.tsx';

export const Route = createFileRoute('/app/developers/docs/')({ component: DocsScreen });
